export function initAirtable() {
    $(document).on('ajax:success', '.upload-to-airtable', event => {
        $(event.target).replaceWith("<i class='fal fa-external-link'></i> Uploaded to Airtable")
    });

    $(document).on('ajax:error', '.upload-to-airtable', event => {
        alert("There was an error pushing to Airtable")
    });
}
